export enum Permission {
  // Ingest Recieps CSV Permission
  AdminPanel = 'admin_panel.legacy_permission',
}
